import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useTimeZone } from '@connect-x-app/hybrid-state';
import { AttachmentData, MessageMention } from '@connect-x-app/shared-domain-models';
import { MessageUtil } from '@connect-x-app/shared-utils';
import { ChatMessage as ChatMessageType } from '@connect-x-app/shared-view-models';
import { SeparatorWithText } from '@connect-x-app/web-ui';

import { MessageBubble } from '../messageBubble';
import { SystemMessage } from '../systemMessage';

type Props = {
  disabled?: boolean;
  focused: boolean;
  message: ChatMessageType;
  nextMessage: ChatMessageType;
  onDelete: (message: ChatMessageType) => void;
  onRetry: (message: ChatMessageType, pendingImage: File | null) => void;
  pendingImage: File | null;
  previousMessage: ChatMessageType | undefined;
  setActiveMention: (mention: MessageMention) => void;
  setAttachmentPreview: (attachment: AttachmentData) => void;
  showMessageInfo: () => void;
  showNewMessagesIndicator: boolean;
};

export const ChatMessage: FC<Props> = ({
  disabled = false,
  focused,
  message,
  nextMessage,
  onDelete,
  onRetry,
  pendingImage,
  previousMessage,
  setActiveMention,
  setAttachmentPreview,
  showMessageInfo,
  showNewMessagesIndicator,
}) => {
  const { t } = useTranslation();
  const { formatTimeInTimeZone } = useTimeZone();

  return (
    <div className="chatbubble">
      {showNewMessagesIndicator ? <SeparatorWithText text={t('CHAT.LIST.SEPARATOR')} /> : null}
      {message.system ? (
        <SystemMessage
          key={message.id}
          level={message.level}
          message={MessageUtil.processSystemMessage(message.text)}
          time={formatTimeInTimeZone(message.createdAt)}
        />
      ) : (
        <MessageBubble
          {...message}
          currentMessage={message}
          disabled={disabled}
          isFocused={focused}
          nextMessage={nextMessage}
          onClickAttachment={setAttachmentPreview}
          onDelete={onDelete}
          onRetry={onRetry}
          pendingFile={pendingImage}
          previousMessage={previousMessage}
          setActiveMention={setActiveMention}
          showMessageInfo={showMessageInfo}
        />
      )}
    </div>
  );
};
